<table mat-table class="mat-table--wide" [dataSource]="serviceReviews">
  <ng-container matColumnDef="select">
    <th mat-header-cell *matHeaderCellDef>
      <mat-checkbox
        (change)="$event ? toggleAllRows() : null"
        [checked]="selection.hasValue() && isAllSelected()"
        [indeterminate]="selection.hasValue() && !isAllSelected()"
      >
      </mat-checkbox>
    </th>
    <td mat-cell *matCellDef="let row">
      <mat-checkbox
        (click)="$event.stopPropagation()"
        (change)="$event ? selection.toggle(row) : null"
        [checked]="selection.isSelected(row)"
      >
      </mat-checkbox>
    </td>
  </ng-container>

  <ng-container matColumnDef="certificationNumber">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'dialog.pull-pre-auth.results-table.certification-number' | translate }}
    </th>
    <td mat-cell *matCellDef="let row">
      {{ row.certificationNumber }}
    </td>
  </ng-container>

  <ng-container matColumnDef="referenceNumber">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'dialog.pull-pre-auth.results-table.reference-number' | translate }}
    </th>
    <td mat-cell *matCellDef="let row">
      {{ row.referenceNumber }}
    </td>
  </ng-container>

  <ng-container matColumnDef="serviceType">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'dialog.pull-pre-auth.results-table.service-type' | translate }}
    </th>
    <td mat-cell *matCellDef="let row">
      {{ row.serviceType }}
    </td>
  </ng-container>

  <ng-container matColumnDef="requestType">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'dialog.pull-pre-auth.results-table.request-type' | translate }}
    </th>
    <td mat-cell *matCellDef="let row">
      {{ ('service-review-request-type.' + row.requestTypeCode) | translate }}
    </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'dialog.pull-pre-auth.results-table.status' | translate }}
    </th>
    <td mat-cell *matCellDef="let row">
      {{ row.statusCode | serviceReviewStatusToAuthStatusText | translate }}
    </td>
  </ng-container>

  <ng-container matColumnDef="procedures">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'dialog.pull-pre-auth.results-table.procedures' | translate }}
    </th>
    <td mat-cell *matCellDef="let row">
      {{ row.procedures | join: 'code' }}
    </td>
  </ng-container>

  <ng-container matColumnDef="issueDate">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'dialog.pull-pre-auth.results-table.issue-date' | translate }}
    </th>
    <td mat-cell *matCellDef="let row">
      {{ row.certificationIssueDate | momentDate }}
    </td>
  </ng-container>

  <ng-container matColumnDef="effectiveDate">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'dialog.pull-pre-auth.results-table.effective-date' | translate }}
    </th>
    <td mat-cell *matCellDef="let row">
      {{ (row.certificationEffectiveDate || row.procedures?.[0]?.fromDate) | momentDate }}
    </td>
  </ng-container>

  <ng-container matColumnDef="expirationDate">
    <th mat-header-cell *matHeaderCellDef>
      {{ 'dialog.pull-pre-auth.results-table.expiration-date' | translate }}
    </th>
    <td mat-cell *matCellDef="let row">
      {{ (row.certificationExpirationDate || row.procedures?.[0]?.toDate) | momentDate }}
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
